import { render, staticRenderFns } from "./SFormExpenseComp.vue?vue&type=template&id=1a83cee8&"
import script from "./SFormExpenseComp.vue?vue&type=script&lang=js&"
export * from "./SFormExpenseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports